export default __webpack_public_path__ + "static/Haier-0ed2f468c74bbda30b624c42aac30fbf.jpg";